import React from 'react'
import { useNavigate } from 'react-router-dom';

function SubMenuItem({ title, path }) {
    const navigate = useNavigate();
    const handleNavigateToPath = () => {
        navigate(path);
    }
    return (
        <li>
            <a onClick={handleNavigateToPath}>{title}</a>
        </li>
    )
}

export default SubMenuItem
